import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { showError } from '../../../../utils/toast';
import { useLoading } from '../../../../components/LoadingProvider';
import useAuth from '../../../../hooks/useAuth';
import api from '../../../../api/axios';
import { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getPublicImgUrl } from '../../../../utils/common';

export default function UploadedReportsPage() {
    const { setIsLoading } = useLoading();
    const [previousReports, setPreviousReports] = useState([]);
    const MySwal = withReactContent(Swal);
    const { user, isAuthenticated, userRole } = useAuth({ redirectPath: '/login', allowedRoles: ['patient'] });

    useEffect(() => {
        document.title = 'Varosa - Patient Uploaded Reports';
        setIsLoading(false);
        showDocuments();
    }, []);

    const showDocuments = async () => {
        setIsLoading(true);
        try {
            const response = await api.get('/patient/documents');
            if (response?.data?.result === 'success') {
                setPreviousReports(response.data.data.documents.previous_report);
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            }else{
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError('Something went wrong! Please try again later.');
        } finally {
            setIsLoading(false);
        }
    }

    const formatBytes = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    const handleDocumentView = (document) => {
        MySwal.fire({
            title: 'Report',
            html: `<iframe src="${document}" alt="Report" style="width: 100%;height: 600px;"></iframe>`,
            width: '90%',
            showConfirmButton: true,
            confirmButtonText: 'Close',
            customClass: {
                container: '',
            },
        });
    }

    const handleCardImgView = (document) => {
        const fileExtension = document.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
            return document;
        }
        return getPublicImgUrl()+"/doc-icon.png";
    }

    return (
        <>
            <div className="container py-5 login-container">
                <div className="row g-3">
                    <div className="col-9">
                        <h2 className="mb-4">My Uploaded Reports</h2>
                    </div>
                    <div className="col-3 text-end">
                        <button onClick={() => window.history.go(-1)} className="btn btn-primary">Back</button>
                    </div>
                </div>
                <div className="row g-3">
                    {/* Previous Uploaded Reports Section */}
                    <div className="col-12">
                        <h4 className="mt-4 mb-3">Previous Reports</h4>
                    </div>
                    <div className="col-12">
                        <div className="row g-3">
                            {previousReports.map((document, index) => (
                                <div className="col-md-4" key={index}>
                                    <div className="card">
                                        <h5 className="card-header text-center d-flex align-items-center justify-content-center" style={{ height: '205px' }}>
                                            <img src={handleCardImgView(document.file_path)} className="img-fluid rounded-2" alt={document.original_name} style={{ height: '160px' }}></img>
                                        </h5>
                                        <div className="card-body">
                                            <h5 className="card-title">{document.original_name} ({formatBytes(document.file_size)})</h5>
                                            <p className="card-text">Uploaded on: {document.uploaded_at}</p>
                                        </div>
                                        <div className="card-footer">
                                            <div className="d-flex justify-content-end">
                                                {/* <button onClick={() => handleDocumentView(document.file_path)} className="btn btn-primary btn-sm">View</button>
                                                <a href={document.file_path} target="_blank" className="btn btn-success btn-sm">View / Download</a> */}
                                                <Link to={document.file_path} target="_blank" className="btn btn-success btn-sm">View / Download</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {previousReports.length === 0 && (
                                <div className="col-12">
                                    <p className="text-muted">No previous reports uploaded.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}